"use client";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import { Typography } from "@/components/ui";

export interface BenefitFeature {
  icon: string;
  title: string;
  description: string;
}
interface BenefitsCardProps {
  feature: BenefitFeature;
  imgBaseUrl?: string;
}

export default function BenefitsCard({ feature, imgBaseUrl }: BenefitsCardProps) {
  const [isClient, setisClient] = useState(false);
  useEffect(() => {
    setisClient(true);
  }, []);
  return (
    <div
      className="p-6 h-full rounded-xl overflow-clip text-center bg-white"
      style={{ boxShadow: "rgba(0, 0, 0, 0.11) 0px 3px 7px" }}
    >
      <div className="w-20 mx-auto">
        <Image
          src={imgBaseUrl ? imgBaseUrl + feature.icon : feature.icon}
          alt={feature.title}
          title={feature.title}
          width={100}
          height={100}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-4">
        <Typography variant="h4" as="h3" className="mb-4">
          {feature.title}
        </Typography>
        {isClient ? (
          <Typography variant="body" as="p">
            <span dangerouslySetInnerHTML={{ __html: feature.description }} />
          </Typography>
        ) : (
          <Typography variant="body">{feature.description}</Typography>
        )}
      </div>
    </div>
  );
}
